import { Box, Button, Flex } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { appContext } from "../Context/AppContext";
import { customerFilters, leadFilters } from "../Config/filter";

export const DataFilter = ({
  updateSourceArray,
  func,
  selectedFilter,
}: any) => {
  const { pageId } = useContext(appContext);
  const filters = ["single", "subscription"].includes(pageId)
    ? customerFilters
    : leadFilters;
  // console.log(selectedFilter);
  const defaultFilters = selectedFilter
    ? [selectedFilter]
    : ["hot-leads", "warm-leads", "cold-leads"].includes(pageId)
    ? ["APP_EHC"]
    : ["APP"];

  const [appliedFilters, setAppliedFilters] =
    useState<string[]>(defaultFilters);

  useEffect(() => {
    setAppliedFilters(defaultFilters);

    updateSourceArray(defaultFilters);

  }, [pageId]);

  return (
    <Box py={3.5}>
      <Flex gap={2} px={4}>
        <Box
          paddingRight="5px"
          borderRight="2px"
          borderRightColor="whiteAlpha.600"
        >
          {filters.map((filter: any, idx: any) => (
            <Button
              bg={appliedFilters.includes(filter) ? "#f5a623" : ""}
              variant={appliedFilters.includes(filter) ? "" : "outline"}
              key={idx}
              colorScheme={
                appliedFilters.includes(filter) ? "black" : "whiteAlpha"
              }
              size="sm"
              px={2}
              py={2}
              mr="5px"
              onClick={() => {
                let updatedFilters;

                if (appliedFilters.includes(filter)) {
                  // Prevent removing the last filter
                  if (appliedFilters.length === 1) {
                    return; // one filter left
                  }
                  updatedFilters = appliedFilters.filter(
                    (item) => item !== filter
                  ); // Remove filter
                } else {
                  updatedFilters = [...appliedFilters, filter]; // Add filter
                }

                setAppliedFilters(updatedFilters);
                updateSourceArray(updatedFilters);
              }}
            >
              {filter}
            </Button>
          ))}
        </Box>
        <Button
          colorScheme="whiteAlpha"
          bg="#70afaf"
          size="sm"
          px={4}
          py={2}
          onClick={() => {
            setAppliedFilters(filters);
            updateSourceArray(filters);
          }}
        >
          CLEAR
        </Button>
      </Flex>
    </Box>
  );
};
